import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';
import type React from 'react';
import HighlightedFragment from 'src/components/HighlightedText/HighlightedFragment';
import HighlightedText from 'src/components/HighlightedText/HighlightedText';
import { useListViewRowContext } from '../ListViewRowContext';

const DynamicFieldCell: React.FC<{ slug?: string }> = ({ slug }) => {
  const { loading, rowType, itemId, fieldsBySlug, highlights, highlightTerms, density, classes, handleNavigate } =
    useListViewRowContext();

  if (loading) {
    return <Skeleton variant="text" width="50%" animation="wave" sx={{ fontSize: density.fontSize }} />;
  }

  if (rowType === 'collection') {
    return <span className={classes.emptyValue}>&mdash;</span>;
  }

  // rowType === 'asset'
  const field = slug ? fieldsBySlug.get(slug) : undefined;

  if (!field) {
    return <span className={classes.emptyValue}>&mdash;</span>;
  }

  const osHighlight = field.slug && highlights?.[field.slug]?.[0];

  const fallbackIcon = field.fallbackMessage ? (
    <Tooltip title={field.fallbackMessage} arrow>
      <WarningAmberIcon sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, verticalAlign: 'middle' }} />
    </Tooltip>
  ) : null;

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled at table row level
    // biome-ignore lint/a11y/noStaticElementInteractions: keyboard navigation handled at table row level
    <span onClick={() => itemId && handleNavigate(itemId)}>
      {osHighlight ? (
        <HighlightedFragment fragment={osHighlight} />
      ) : (
        <HighlightedText
          highlightTexts={[highlightTerms.searchTerm, highlightTerms.hasPhrase, ...highlightTerms.hasWords]}
          text={field.show ?? ''}
        />
      )}
      {fallbackIcon}
    </span>
  );
};

export default DynamicFieldCell;
